import * as React from 'react'
import PropTypes from 'prop-types'
import Tabs from '@mui/material/Tabs'
import Tab from '@mui/material/Tab'
import Typography from '@mui/material/Typography'
import Box from '@mui/material/Box'

function TabPanel(props) {
  const { children, value, index, ...other } = props

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 0 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  )
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
}

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  }
}

export default function TabsComponent({
  tabsHeader,
  tabsPanel,
  children,
  handleChangeTab,
  orientation = 'horizontal',
  variant = 'standard',
}) {
  const [value, setValue] = React.useState(0)

  const handleChange = (event, newValue) => {
    setValue(newValue)
    if (handleChangeTab) {
      handleChangeTab(newValue)
    }
  }

  return (
    <Box sx={{ width: '100%' }}>
      <Tabs
        value={value}
        onChange={handleChange}
        aria-label="basic tabs"
        orientation={orientation}
        variant={variant}
      >
        {tabsHeader.map((header, index) => {
          return <Tab label={header.label} {...a11yProps(index)} />
        })}
      </Tabs>

      {tabsPanel.map((panel, index) => {
        return (
          <TabPanel value={value} index={index}>
            {children ? children : panel}
          </TabPanel>
        )
      })}
    </Box>
  )
}
